import React, { createContext, useContext, useState } from 'react';
import { startOfMonth, endOfDay } from "date-fns";

const DateRangeContext = createContext();

export const DateRangeProvider = ({ children }) => {
    const [startDate, setStartDate] = useState(startOfMonth(new Date()));
    const [endDate, setEndDate] = useState(endOfDay(new Date()));
    
    return (
        <DateRangeContext.Provider value={{ startDate, setStartDate, endDate, setEndDate }}>
            {children}
        </DateRangeContext.Provider>
    );
};

export const useDateRangeContext = () => useContext(DateRangeContext);